import { render, staticRenderFns } from "./EditFamilyMember.vue?vue&type=template&id=6ea061de&scoped=true"
import script from "./EditFamilyMember.vue?vue&type=script&lang=ts"
export * from "./EditFamilyMember.vue?vue&type=script&lang=ts"
import style0 from "./EditFamilyMember.vue?vue&type=style&index=0&id=6ea061de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea061de",
  null
  
)

export default component.exports